import { TableColumnsType } from 'antd';
import moment from 'moment';
import * as S from './styles';
import { Icons } from '@assets';
import React from 'react';
import { ICardForm, ITemplate } from '@entities/card/types';
import { StyledTemplate } from '@pages/crm/components/content/StyledTemplate';

export const getCardsColumns = (
    handlerClickId: (
        id: number,
        e: React.MouseEvent<HTMLSpanElement, MouseEvent>
    ) => void
): TableColumnsType<ICardForm> => {
    return [
        {
            title: '№ Формы',
            dataIndex: 'id',
            align: 'center',
            width: '8%',
            responsive: ['xl', 'lg', 'md', 'sm', 'xs'],

            render: id => (
                <S.StyledLink
                    onClick={e => handlerClickId(id, e)}
                    role="button"
                    tabIndex={0}
                >
                    {id}
                </S.StyledLink>
            ),
        },
        {
            title: 'Наименование формы',
            dataIndex: 'name',
            responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
            width: '17%',
            render: record => {
                return <S.CSpan>{record}</S.CSpan>;
            },
        },

        {
            title: 'Статус',
            dataIndex: 'state',
            align: 'center',
            width: '10%',

            render: (state: number) => {
                return (
                    <S.TextWrapper>
                        {state === 1 ? (
                            <img src={Icons.CircleCheck} alt="icon check" />
                        ) : (
                            <img src={Icons.CircleMissed} alt="icon missed" />
                        )}
                    </S.TextWrapper>
                );
            },
        },

        {
            title: <div style={{ marginLeft: '5px' }}>Дата создания</div>,
            dataIndex: 'createdAt',
            responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
            width: '25%',

            render: record => {
                return (
                    <S.DateWrapper>
                        <S.StyledSpan>
                            {record ? moment(record).format('DD.MM.YYYY') : '-'}
                        </S.StyledSpan>
                    </S.DateWrapper>
                );
            },
        },
        {
            title: 'Кол-во пользователей',
            dataIndex: 'cardsCount',
            responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
            width: '20%',
            render: record => {
                return <S.CSpan>{record}</S.CSpan>;
            },
        },
        {
            title: 'Макет',
            width: '15%',
            dataIndex: 'template',
            responsive: ['xl', 'lg', 'md', 'sm', 'xs'],

            render: (template: ITemplate | null) => (
                <>
                    {template ? (
                        <StyledTemplate
                            key={template.id}
                            template={template}
                            ind={1}
                        />
                    ) : (
                        <span>-</span>
                    )}
                </>
            ),
        },
    ];
};
